export function buildFormData(
  fields: Record<string, unknown>,
  file?: File | null,
  fileField = 'file',
): FormData {
  const fd = new FormData();

  if (file) {
    fd.append(fileField, file);
  }

  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (typeof value === 'object') {
      fd.append(key, JSON.stringify(value));
      return;
    }

    fd.append(key, String(value));
  });

  return fd;
}
